import { useState, useEffect } from 'react';

export default function Timer({isActive}) {
  const [secondsLeft, setSeconds] = useState(0)

  const hours = parseInt(secondsLeft / 3600);
  const minutes = parseInt(secondsLeft / 60); // Math.floor
  const seconds = parseInt(secondsLeft % 60);

  useEffect(() => {
    let interval = null
    /*interval = setInterval(() => {
        setSeconds(seconds_left => seconds_left + 1)
    }, 1000);*/
    if (isActive) {
        interval = setInterval(() => {
            setSeconds(secondsLeft => secondsLeft + 1);
        }, 1000)
    } else {
        clearInterval(interval)
    }

    return () => clearInterval(interval)
  }, [isActive, secondsLeft]);

  return hours >= 1 ? <span>{hours}&nbsp;ч.&nbsp;{minutes}&nbsp;мин.&nbsp;{seconds}&nbsp;сек.</span> 
    : minutes > 0 ? <span>{minutes}&nbsp;мин.&nbsp;{seconds}&nbsp;сек.</span> 
      : <span>{seconds}&nbsp;сек.</span>
}